import { render, staticRenderFns } from "./GBranchOfficeList.vue?vue&type=template&id=3526b0f2&lang=pug&"
import script from "./GBranchOfficeList.vue?vue&type=script&lang=js&"
export * from "./GBranchOfficeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GBranchOfficeList.vue"
export default component.exports